import { configProps } from "../../types";

export const companiesConfig: configProps<"companies"> = {
  view: "companies",
  title: "Firmy",
  columns: [
    {
      id: 1,
      field: "name",
      header: "Firma",
      isDefaultVisible: true,
      className: "column--small",
      inputType: "text",
      required: true,
      sortable: true,
    },
    {
      id: 2,
      field: "registryCode",
      header: "Kod rejestracyjny",
      isDefaultVisible: true,
      className: "column--small",
      inputType: "text",
      required: true,
      sortable: true,
    },
    {
      id: 3,
      field: "legalAddress",
      header: "Adres prawny",
      isDefaultVisible: true,
      className: "column--small",
      inputType: "text",
    },
    {
      id: 4,
      field: "isSupplier",
      header: "Zakup",
      isDefaultVisible: true,
      className: "column--small",
      editable: false,
      body: (rowData) =>
        rowData.isSupplier ? (
          <i
            className="pi pi-check"
            style={{ color: "var(--highlight-text-color)" }}
          ></i>
        ) : (
          ""
        ),
    },
    {
      id: 5,
      field: "isTransporter",
      header: "Przewożnik",
      isDefaultVisible: true,
      className: "column--small",
      editable: false,
      body: (rowData) =>
        rowData.isTransporter ? (
          <i
            className="pi pi-check"
            style={{ color: "var(--highlight-text-color)" }}
          ></i>
        ) : (
          ""
        ),
    },
    {
      id: 6,
      field: "isBuyer",
      header: "Sprzedaz",
      isDefaultVisible: true,
      className: "column--small",
      editable: false,
      body: (rowData) =>
        rowData.isBuyer ? (
          <i
            className="pi pi-check"
            style={{ color: "var(--highlight-text-color)" }}
          ></i>
        ) : (
          ""
        ),
    },
  ],
};
